import { Button } from '@talentmesh/ui/components/button';
import { Spinner } from '@talentmesh/ui/components/spinner';
import { useIdentifiedListContext } from '../utils/IdentifiedListContext';
import { useRefineSearchCriteriaFormContext } from './useRefineSearchCriteriaForm';
import { useRefineSearchFiltersFormContext } from './useRefineSearchFiltersForm';
import UIStrings from '@/Utils/UIStrings';

interface RefineSearchHeaderProps {
    title: string;
    onCancel: () => void;
    useFormContext: typeof useRefineSearchFiltersFormContext | typeof useRefineSearchCriteriaFormContext;
}

const RefineSearchHeader = ({ title, onCancel, useFormContext }: RefineSearchHeaderProps) => {
    const { data } = useIdentifiedListContext();
    const form = useFormContext();

    return (
        <div className="flex items-center justify-between">
            <div className="text-foreground">
                <span className="text-xl font-bold">{`${title} `}</span>
                <span className="text-xl font-normal">
                    ({UIStrings.NumberOfCandidatesIdentified(data?.pagination.totalCount || 0)})
                </span>
            </div>
            <div className="flex items-center gap-2.5">
                <Button type="button" variant="ghost" size="lg" onClick={onCancel}>
                    {UIStrings.Cancel}
                </Button>
                <Button
                    variant="default"
                    size="lg"
                    type="submit"
                    disabled={!form.formState.isDirty || form.formState.isSubmitting}
                >
                    {form.formState.isSubmitting && <Spinner className="mr-2 h-4 w-4" />}
                    {UIStrings.ApplyChanges}
                </Button>
            </div>
        </div>
    );
};

export default RefineSearchHeader;
